import React, { useState, useEffect } from 'react';
import env from '../../config';

const API_ROOT = env.backendUrl && env.backendUrl.endsWith('/api')
  ? env.backendUrl.replace(/\/$/, '')
  : `${env.backendUrl.replace(/\/$/, '')}/api`;

const API_URL = `${API_ROOT}/blockings`;

export default function Blockings() {
  const [items, setItems] = useState([]);
  const [form, setForm] = useState({
    id: null,
    pessoa: '',
    objeto: '',
    periodo: '',
  });

  const [loading, setLoading] = useState(true);
  const [editing, setEditing] = useState(false);
  const [error, setError] = useState(null);

  const today = (() => {
    const d = new Date();
    return d.toISOString().split('T')[0];
  })();

  useEffect(() => {
    fetchAll();
  }, []);

  useEffect(() => {
    document.title = 'Meninos - Blockings';
  }, []);

  async function fetchAll() {
    setLoading(true);

    try {
      const res = await fetch(API_URL, {
        headers: {
          Accept: 'application/json',
        },
      });

      const json = await res.json();
      setItems(Array.isArray(json) ? json : []);
    } catch (e) {
      console.error(e);
      setError('Erro ao carregar.');
    } finally {
      setLoading(false);
    }
  }

  function handleChange(e) {
    const { name, value } = e.target;

    setForm((old) => ({
      ...old,
      [name]: value,
    }));
  }

  function startEdit(item) {
    setEditing(true);

    setForm({
      id: item.id,
      pessoa: item.pessoa || '',
      objeto: item.objeto || '',
      periodo: item.periodo || today,
    });
  }

  function cancel() {
    setEditing(false);

    setForm({
      id: null,
      pessoa: '',
      objeto: '',
      periodo: today,
    });

    setError(null);
  }

  async function submit(e) {
    e.preventDefault();

    try {
      const method = editing ? 'PUT' : 'POST';

      const url = editing
        ? `${API_URL}/${form.id}`
        : API_URL;

      const res = await fetch(url, {
        method,
        headers: {
          'Content-Type': 'application/json',
          Accept: 'application/json',
        },
        body: JSON.stringify(form),
      });

      if (!res.ok) throw new Error();

      await fetchAll();
      cancel();

    } catch (e) {
      console.error(e);
      setError('Erro ao salvar.');
    }
  }

  async function remove(id) {
    if (!window.confirm('Confirmar exclusão?')) return;

    try {
      const res = await fetch(`${API_URL}/${id}`, {
        method: 'DELETE',
        headers: {
          Accept: 'application/json',
        },
      });

      if (!res.ok) throw new Error();

      setItems((old) => old.filter((x) => x.id !== id));

    } catch (e) {
      console.error(e);
      setError('Erro ao excluir.');
    }
  }

  function formatShortDate(date) {
    if (!date) return '';

    const [y, m, d] = date.split('-').map(Number);

    return new Date(y, m - 1, d).toLocaleDateString('en-US', {
      month: '2-digit',
      day: '2-digit',
    });
  }

  if (loading) {
    return (
      <div className="p-6 text-center">
        Carregando...
      </div>
    );
  }

  return (
    <div className="container mx-auto p-4 md:p-8">

      <h1 className="text-2xl font-bold mb-6">
        Bloqueios
      </h1>

      <div className="bg-white rounded shadow p-4 mb-6">

        <h2 className="font-semibold mb-4">
          {editing ? 'Editar Bloqueio' : 'Novo Bloqueio'}
        </h2>

        {error && (
          <div className="text-red-600 mb-3">
            {error}
          </div>
        )}

        <form
          onSubmit={submit}
          className="grid grid-cols-1 md:grid-cols-4 gap-3"
        >

          <input
            type="date"
            name="periodo"
            value={form.periodo}
            onChange={handleChange}
            className="border rounded p-2"
            required
          />

          <select
            name="pessoa"
            value={form.pessoa}
            onChange={handleChange}
            className="border rounded p-2"
            required
          >
            <option value="">Selecione</option>
            <option value="felipe">Felipe</option>
            <option value="miguel">Miguel</option>
          </select>

          <input
            type="text"
            name="objeto"
            value={form.objeto}
            onChange={handleChange}
            placeholder="Objeto"
            className="border rounded p-2 md:col-span-2"
            required
          />

          <div className="md:col-span-4 flex justify-end gap-2">

            {editing && (
              <button
                type="button"
                onClick={cancel}
                className="bg-gray-200 px-4 py-2 rounded"
              >
                Cancelar
              </button>
            )}

            <button
              type="submit"
              className="bg-indigo-600 text-white px-4 py-2 rounded"
            >
              {editing ? 'Salvar' : 'Criar'}
            </button>

          </div>

        </form>

      </div>

      <div className="bg-white rounded shadow p-4">

        <h2 className="font-semibold mb-4">
          Lista
        </h2>

        {items.length === 0 && (
          <div className="text-gray-500">
            Nenhum bloqueio encontrado.
          </div>
        )}

        {/* MOBILE */}

        <div className="md:hidden space-y-3">

          {items.map((it) => (

            <div
              key={it.id}
              className="border rounded-lg p-4 shadow-sm"
            >

              <div className="flex justify-between items-start">

                <div>

                  <div className="font-semibold capitalize text-lg">
                    {it.pessoa}
                  </div>

                  <div className="text-sm text-gray-500">
                    Até {formatShortDate(it.periodo)}
                  </div>

                </div>

              </div>

              <div className="mt-3 break-words text-gray-800">
                {it.objeto}
              </div>

              <div className="flex justify-end gap-6 mt-4">

                <button
                  onClick={() => startEdit(it)}
                  className="text-indigo-600 font-medium"
                >
                  Editar
                </button>

                <button
                  onClick={() => remove(it.id)}
                  className="text-red-600 font-medium"
                >
                  Excluir
                </button>

              </div>

            </div>

          ))}

        </div>

        {/* DESKTOP */}

        <div className="hidden md:block overflow-x-auto">

          <table className="min-w-full">

            <thead className="bg-gray-50">

              <tr>

                <th className="text-left px-4 py-2">
                  Até
                </th>

                <th className="text-left px-4 py-2">
                  Pessoa
                </th>

                <th className="text-left px-4 py-2">
                  Objeto
                </th>

                <th className="text-right px-4 py-2">
                  Ações
                </th>

              </tr>

            </thead>

            <tbody>

              {items.map((it) => (

                <tr
                  key={it.id}
                  className="border-t hover:bg-gray-50"
                >

                  <td className="px-4 py-3">
                    {formatShortDate(it.periodo)}
                  </td>

                  <td className="px-4 py-3 capitalize">
                    {it.pessoa}
                  </td>

                  <td className="px-4 py-3">
                    {it.objeto}
                  </td>

                  <td className="px-4 py-3 text-right">

                    <button
                      onClick={() => startEdit(it)}
                      className="text-indigo-600 mr-4"
                    >
                      Editar
                    </button>

                    <button
                      onClick={() => remove(it.id)}
                      className="text-red-600"
                    >
                      Excluir
                    </button>

                  </td>

                </tr>

              ))}

            </tbody>

          </table>

        </div>

      </div>

    </div>
  );
}